<div [style]="styles.container_padding" *ngIf="report">
      
  <div [style]="styles.page_header"></div>
  <h1 [style]="styles.general_h1"><b>SCORES SUMMARY</b></h1>
  <h2 [style]="styles.general_h2"><b>{{ preferenceScore }}</b></h2>

  <div [style]="styles.graph">
    <lib-chart
      canvasId="CoachingStyle"
      [labels]="report.graph.CoachingStyle.labels"
      [data]="report.graph.CoachingStyle.scores"
      background="#266cf7"
      [height]="coachingStyleHeight"
      [base64]="download"
    />
  </div>

  <h2 [style]="styles.general_h2"><b>{{ expressionScore }}</b></h2>

  <div [style]="styles.graph">
    <lib-chart
      canvasId="DirectIndirect"
      [labels]="report.graph.DirectIndirect.labels"
      [data]="report.graph.DirectIndirect.scores"
      background="#123478"
      [padding]="55"
      [height]="directIndirectHeight"
      [base64]="download"
    />
  </div>

</div>